import script from "./Prospectos.vue?vue&type=script&setup=true&lang=js"
export * from "./Prospectos.vue?vue&type=script&setup=true&lang=js"

import "./Prospectos.vue?vue&type=style&index=0&id=423ee11c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423ee11c"]])

export default __exports__